import { List, ListItemButton, ListItemIcon, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import ThemeAction from "../../redux/actions/ThemeAction";

const SidebarItem = (props) => {
  const dispatch = useDispatch();

  const changeDropDownBool = (bool) => {
    dispatch(ThemeAction.setSideBarOpen(bool));

  };
  const active = props.route === window.location.pathname;
  const [open, setOpen] = useState(false);
  if (props.collapse) {
    return (
      <>
        <ListItemButton
          style={{
            background: active ? "var(--main-color)" : "",
            color: active ? "var(--second-color)" : "",
          }}
          className={`sidebar__item ${props.className}`}
          onClick={() => {
            setOpen(!open);
            props.collapseHandler(!props.collapsem);
          }}
        >
          <div className={`sidebar__item-inner `}>
            <ListItemIcon sx={{ p: 0, minWidth: "30px" }}>
              {props.icon}
            </ListItemIcon>
            <span className="me-2">{props.title}</span>
            {open ? <ExpandLess /> : <ExpandMore />}
          </div>
        </ListItemButton>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {props.collapse.map((item, index) => (
              <Link to={item.route} key={index}>
                <ListItemButton
                  sx={{ pl: 5 }}
                  style={{
                    background:
                      item.route === window.location.pathname
                        ? "var(--main-color)"
                        : "",
                    color:
                      item.route === window.location.pathname
                        ? "var(--second-color)"
                        : "",
                  }}
                >
                  {" "}
                  <div className={`sidebar__item-inner `}>
                    <ListItemIcon style={{ margin: 0, padding: 0 }}>
                      <p style={{ margin: 0, padding: 0 }}>{item.icon}</p>
                    </ListItemIcon>

                    <span>{item.display_name}</span>
                  </div>
                </ListItemButton>
              </Link>
            ))}
          </List>
        </Collapse>
      </>
    );
  } else
    return (
      <ListItemButton
        className={`sidebar__item ${props.className}`}
        style={{
          background: active ? "var(--third-color-blue)" : "",
          width: "100%",
        }}
        onClick={() => {
          changeDropDownBool(false);
        }}
      >
        <div className={`sidebar__item-inner`}>
          <ListItemIcon sx={{ p: 0, minWidth: "30px" }}>
            {props.icon}
          </ListItemIcon>
          <span className="text-decoration-none">{props.title}</span>
        </div>
      </ListItemButton>
    );
};

export default SidebarItem;
